import SysLoading from "./SysLoading";
import SysSwiper from "./SysSwiper";
import SysDialog from "./SysDialog";
import captcha from "./captcha.vue";

const sysLoading = {
  install: Vue => {
    Vue.component("SysLoading", SysLoading);
  }
};

const sysSwiper = {
  install: Vue => {
    Vue.component("SysSwiper", SysSwiper);
  }
};

const sysDialog = {
  install: Vue => {
    Vue.component("SysDialog", SysDialog);
    Vue.component("vCaptcha", captcha);
  }
};

export { sysLoading, sysSwiper, sysDialog };



// WEBPACK FOOTER //
// ./src/components/common/index.js